import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { createAccount } from "../api/functions";

export function CreateAccountPage() {
  const navigate = useNavigate();
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [name, setName]         = useState("");
  const [busy, setBusy]         = useState(false);
  const [error, setError]       = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const r = await createAccount({ email: email.trim(), password, name: name.trim() });
      navigate(`/admin/accounts/${r.accountId}`);
    } catch (err) {
      setError((err as { message?: string }).message ?? "Failed to create account");
      setBusy(false);
    }
  };

  return (
    <div className="max-w-lg space-y-6">
      <div className="text-sm text-slate-500">
        <Link to="/admin" className="hover:underline">← Back to accounts</Link>
      </div>
      <h1 className="text-2xl font-semibold text-slate-800">New account</h1>

      <form onSubmit={onSubmit} className="bg-white rounded-lg shadow p-6 space-y-4">
        <Field label="Restaurant / customer name">
          <input
            value={name}
            onChange={e => setName(e.target.value)}
            required
            className="mt-1 block w-full rounded-md border-slate-300 border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </Field>

        <Field label="Login email">
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            className="mt-1 block w-full rounded-md border-slate-300 border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </Field>

        <Field label="Password (min 8 chars)">
          <input
            type="text"
            value={password}
            onChange={e => setPassword(e.target.value)}
            minLength={8}
            required
            className="mt-1 block w-full rounded-md border-slate-300 border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
          <p className="text-xs text-slate-500 mt-1">
            Type something like <code className="font-mono">DinFlow@2026</code> — this is what you'll send to the customer.
          </p>
        </Field>

        {error && <div className="text-sm text-red-600">{error}</div>}

        <button
          type="submit"
          disabled={busy}
          className="bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 text-white font-medium rounded-md px-5 py-2"
        >
          {busy ? "Creating…" : "Create account"}
        </button>
      </form>
    </div>
  );
}

function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <label className="block">
      <span className="text-sm text-slate-700">{label}</span>
      {children}
    </label>
  );
}
